import React__default from 'react';
import { Row, Col } from 'antd';

function DmCountry(props) {
  var name = props.name,
    icon = props.icon,
    size = props.size,
    flagOnly = props.flagOnly,
    className = props.className,
    textStyles = props.textStyles;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Row, {
    className: "\n          ".concat(size === 'small' ? 'dm-country-row-small dm-country-row' : 'dm-country-row-large dm-country-row', " ").concat(className, " ")
  }, /*#__PURE__*/React__default.createElement(Col, {
    className: "dm-country-col"
  }, icon), !flagOnly && /*#__PURE__*/React__default.createElement(Col, {
    className: size === 'small' ? 'dm-country-col-small dm-country-col' : 'dm-country-col-large dm-country-col',
    style: textStyles
  }, name)));
}
DmCountry.defaultProps = {
  name: undefined,
  icon: null,
  size: 'large',
  flagOnly: false,
  className: undefined
  // style: undefined,
};

export { DmCountry as default };
